import axios from "axios";
import I18n from "@/services/i18n";
import { neoparentUsers } from "@/api";

// Look for node.js backend path in config depending on ENV
let backendRoot = process.env.VUE_APP_API_ROUTE;

// Logs only in dev env
export function consoleLog(text) {
  if (process.env.NODE_ENV !== "production") {
    console.log(text);
  }
}

// Redirect
export function redirect(path) {
  window.location.href = path;
}

export async function uploadFile(file) {
  const formData = new FormData();
  formData.append("access", file.access);
  formData.append("file", file);

  return axios({
    method: "post",
    url: backendRoot + "/api/upload",
    data: formData,
    config: { headers: { "Content-Type": "multipart/form-data" } }
  });
}

// Don't use the patientId from the JWT but a custom one
// For nurses, patientID is not in token
export async function uploadFileWithId(file, token, patientId) {
  const formData = new FormData();
  formData.append("token", token);
  formData.append("access", file.access);
  formData.append("patientId", patientId);
  formData.append("file", file);

  return axios({
    method: "post",
    url: backendRoot + "/uploads",
    data: formData,
    config: { headers: { "Content-Type": "multipart/form-data" } }
  });
}

export function setImgPreview(imgId, file) {
  const reader = new FileReader();
  reader.onload = function(e) {
    document.getElementById(imgId).setAttribute("src", e.target.result);
  };
  reader.readAsDataURL(file);
}

export function getNotifications() {
  return neoparentUsers.getNotificationsForUser();
}

export function validatePassword(pass) {
  if (
    pass !== "" &&
    pass.length >= 8 &&
    /[a-z]/.test(pass) &&
    /[A-Z]/.test(pass) &&
    /\d/.test(pass)
  ) {
    return true;
  } else {
    return false;
  }
}

/**
 * Determine the mobile operating system.
 * This function returns one of 'iOS', 'Android', 'Windows Phone', or 'unknown'.
 *
 * @returns {String}
 */
export function getMobileOS() {
  var userAgent = navigator.userAgent || navigator.vendor || window.opera;

  // Windows Phone must come first because its UA also contains "Android"
  if (/windows phone/i.test(userAgent)) {
    return "Windows Phone";
  }

  if (/android/i.test(userAgent)) {
    return "Android";
  }

  // iOS detection from: http://stackoverflow.com/a/9039885/177710
  if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
    return "iOS";
  }

  return "unknown";
}

// Get all available languages
export function getSupportedLocales(mode, language) {
  const locales = require.context(
    "@/services/locales",
    true,
    /[A-Za-z0-9-_,\s]+\.json$/i
  );
  const languages = [];
  locales.keys().forEach(key => {
    const matched = key.match(/([A-Za-z0-9-_]+)\./i);
    if (matched && matched.length > 1) {
      languages.push(matched[1]);
    }
  });

  if (mode === "all"){
    languages.push("pl")
    languages.push("bg")
    languages.push("ro")
    languages.push("hu")
    languages.push("es")
    languages.push("pt")
    languages.push("it")
    languages.push("tr")
    languages.push("ar")
    languages.push("cs")
    languages.push("uk")
  }

  if (I18n) {
    return languages.sort((a, b) => {
      let aTranslated = I18n.t(`general.languages.${a}`, language)
      let bTranslated = I18n.t(`general.languages.${b}`, language)
      return aTranslated.localeCompare(bTranslated)
    });
  } else {
    return languages.sort((a, b) => a.localeCompare(b))
  }
}
